import React from 'react';
import { FaqData } from '../types';
import { createTrackingCallback } from '../../utils/getPageSectionName';
const isSsr = typeof window === 'undefined';

type QAPageProps = {
  faq: FaqData[];
  pageUrl?: string;
  title?: string;
  bookNowString?: string;
  pageName?: string;
};

export default function QAPage({
  faq,
  pageUrl,
  title = 'Questions and Answers',
  bookNowString = 'Book Now',
  pageName
}: QAPageProps) {
  return (
    <section>
      <h2 className="railSeoWrap__qa--title font22 latoBold appendBottom15">{title}</h2>
      <div className="railSeoWrap__qa">
        <ul itemScope itemType="https://schema.org/QAPage">
          {faq?.length > 0 &&
            faq.map(({ question, answer }) => (
              <li className="makeFlex column font14 appendBottom20" key={question}>
                <div itemProp="mainEntity" itemScope itemType="http://schema.org/Question">
                  <h3 className="lineHeight28">
                    <span
                      style={{ wordBreak: 'break-word' }}
                      className="appendBottom5"
                      itemProp="name"
                      dangerouslySetInnerHTML={{
                        __html: question
                      }}
                    />
                  </h3>
                  <div
                    className="darkGreyText lineHeight20 appendTop10"
                    itemProp="acceptedAnswer"
                    itemScope
                    itemType="http://schema.org/Answer"
                  >
                    <div itemProp="text">
                      <p
                        style={{ wordBreak: 'break-word' }}
                        dangerouslySetInnerHTML={{
                          __html: isSsr ? answer : unescape(answer)
                        }}
                      />
                      &nbsp;
                      {pageUrl && (
                        <a
                          className="bookNow"
                          href={pageUrl}
                          onClick={createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_faq_booknow')}
                        >
                          {bookNowString}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </section>
  );
}
